import { ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Switch } from '@mui/material';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';
import Permission from 'shared/features/auth/authorization/enums/permission';

import './permission-group-permissions-component.scss';

interface IProps {
  permissions: Array<Permission>;
  viewingMode: ViewingMode;
}

function PermissionGroupPermissionsComponent(props: Readonly<IProps>): ReactElement {
  const { t } = useTranslation('permissions');
  const { control } = useFormContext();

  function translatePermission(permission: Permission) {
    return t(`permissions.${permission}`);
  }

  const sortedPermission = [...props.permissions].sort((x, y) => translatePermission(x).localeCompare(translatePermission(y)));

  return (
    <div className="permission-group-detail">
      {sortedPermission.map((permission) => (
        <div className="permission-container" key={`permission-container-${permission}`}>
          <Controller
            name={`permissions.${permission}`}
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Switch
                    {...field}
                    type="checkbox"
                    value={field.value}
                    checked={field.value}
                    disabled={props.viewingMode === 'viewing'}
                    // prettier-ignore
                    // @ts-ignore
                    inputProps={{ "data-testid": `permissionSwitch${permission}` }}
                  />
                }
                label={translatePermission(permission)}
              />
            )}
          />
        </div>
      ))}
    </div>
  );
}

export default PermissionGroupPermissionsComponent;
